import * as errorHandler from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import {
  SET_BLACKLIST_PAYMENT_METHOD_IN_BILLERS,
  SET_LIST_PAYMENT_METHOD,
  PROCESSING,
} from './types';
const { allBillerApiService, cdnApiService } = apiService.getInstance();

// Setter Payload Data
export const setListPaymentMethod = data => ({
  type: SET_LIST_PAYMENT_METHOD,
  payload: data,
});

export const setBlacklistPaymentMethodInBillers = data => ({
  type: SET_BLACKLIST_PAYMENT_METHOD_IN_BILLERS,
  payload: data,
});

export const getListPaymentMethod = params => async dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  // Do Load Data Payment Method
  try {
    const response = await allBillerApiService.get('paymentMethods', {
      params,
    });
    if (response.status === 200) {
      const { payload } = response.data;
      const sortingPaymentMethod = (a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      };
      try {
        payload.sort(sortingPaymentMethod);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
      dispatch(paymentMethods.setListPaymentMethod(payload));
    } else {
      errorHandler.errorHandle(response);
      dispatch(paymentMethods.setListPaymentMethod([]));
    }
  } catch (error) {
    errorHandler.errorHandle(error);
    dispatch(paymentMethods.setListPaymentMethod([]));
  }
};

export const getBlacklistPaymentMethodInBillers = params => async dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  // Do Load Data Payment Method
  try {
    const response = await cdnApiService.get(
      '/resource/json/lifestyle/test/all-biller-blacklist-payment-method.json',
      { params },
    );
    if (response.status === 200) {
      const { data } = response;
      dispatch(paymentMethods.setBlacklistPaymentMethodInBillers(data));
    } else {
      errorHandler.errorHandle(response);
      dispatch(paymentMethods.setBlacklistPaymentMethodInBillers({}));
    }
  } catch (error) {
    errorHandler.errorHandle(error);
    dispatch(paymentMethods.setBlacklistPaymentMethodInBillers({}));
  }
};

const paymentMethods = {
  setListPaymentMethod,
  getListPaymentMethod,
  setBlacklistPaymentMethodInBillers,
  getBlacklistPaymentMethodInBillers,
};

export default paymentMethods;
